import { Button } from '@/components/ui-kit/button';
import { Card, CardContent } from '@/components/ui-kit/card';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface FormBuilderTabProps {
  templateId: string;
}

export const FormBuilderTab = ({ templateId }: FormBuilderTabProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent className="py-12">
        <div className="text-center space-y-4 max-w-md mx-auto">
          <div className="h-16 w-16 mx-auto rounded-full bg-selise-blue/10 flex items-center justify-center">
            <FileText className="h-8 w-8 text-selise-blue" />
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-[hsl(var(--fg))]">
              {t('ORGTEMPLATES_EDIT_FORMBUILDER_TITLE')}
            </h3>
            <p className="text-sm text-globe-grey">
              {t('ADMIN_TEMPLATES_EDIT_FORMBUILDER_DESCRIPTION')}
            </p>
          </div>
          <div className="flex flex-row gap-3 justify-center items-center pt-4">
            <Button
              variant={'primary'}
              size="sm"
              onClick={() => navigate(`/admin/templates/${templateId}/builder`)}
              className="gap-2"
            >
              <FileText className="h-4 w-4" />
              {t('ORGTEMPLATES_EDIT_FORMBUILDER_OPEN')}
            </Button>
            <Button
              variant={'primaryOutline'}
              size="sm"
              onClick={() => navigate(`/admin/templates/${templateId}/classic-builder`)}
            >
              {t('ADMIN_TEMPLATES_EDIT_FORMBUILDER_CLASSICCTA')}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default FormBuilderTab;
